import { render, staticRenderFns } from "./TabVacation.vue?vue&type=template&id=2468425f"
import script from "./TabVacation.vue?vue&type=script&lang=js"
export * from "./TabVacation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports